import React from 'react';
import { Target } from 'lucide-react';

interface RecommendedActionsCardProps {
  actions: string[];
}

export function RecommendedActionsCard({ actions }: RecommendedActionsCardProps) {
  if (!actions.length) return null;

  return (
    <div
      className="mt-3 rounded-lg overflow-hidden border"
      style={{ backgroundColor: '#eff6f3', borderColor: '#d4e5dc' }}
      data-testid="recommended-actions-card"
    >
      <div
        className="flex items-center gap-1.5 px-3 py-1.5 border-b"
        style={{ backgroundColor: '#e0f0e8', borderColor: '#d4e5dc' }}
      >
        <Target className="h-3.5 w-3.5" style={{ color: '#2d7d46' }} />
        <span className="text-xs font-semibold" style={{ color: '#4a6b55' }}>Recommended Actions</span>
      </div>
      <ul className="px-3 py-2 space-y-1.5">
        {actions.map((action, idx) => (
          <li key={idx} className="flex gap-2 text-sm leading-snug" style={{ color: '#3d5a4a' }}>
            <span
              className="shrink-0 mt-0.5 h-4 w-4 rounded-full text-[10px] font-bold flex items-center justify-center"
              style={{ backgroundColor: '#d4e5dc', color: '#2d7d46' }}
            >
              {idx + 1}
            </span>
            <span>{action}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
